import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";

import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";

import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import ModalFormUpdate from "./ModalFormUpdate/ModalFormUpdate";

const ModalConfigSkeletonFixture = ({ open, setOpen }) => {
  const { idevent, idsport } = useParams();
  const [skeleton, setSkeleton] = useState([]);
  const [clearForm, setClearForm] = useState(true);
  const [formData, setFormData] = useState({
    idtypephase: "",
    nro_fecha: "",
    idgrupo1: "",
    nro_grupo1: "",
    idgrupo2: "",
    nro_grupo2: "",
    date_match: "",
    time_match: "",
    idsede: "",
    tag_final: "",
    nro_match: "",
  });

  const [selectedRow, setSelectedRow] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  useEffect(() => {
    if (idevent && idsport) {
      fetchSkeletonMatches();
    }
  }, [idevent, idsport]);

  const fetchSkeletonMatches = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/getskeletonmatches`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });

      // Ordenar los registros por nro_match antes de establecer el estado
      const sortedMatches = response.data.sort((a, b) => a.nro_match - b.nro_match);
      setSkeleton(sortedMatches);
    } catch (error) {
      console.error("Error al obtener los registros", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formattedDate = `${formData.date_match}`;
      await axios.post(`${API_BASE_URL}/createskeletonmatch`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
        ...formData,
        date_match: formattedDate,
      });

      toast.success("Registro exitoso");
      fetchSkeletonMatches();

      if (clearForm) {
        setFormData({});
      }
    } catch (error) {
      toast.error("Error al registrar");
      console.error("Error al crear el registro", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRowClick = (item) => {
    setSelectedRow(item);
    setIsUpdateModalOpen(true);
  };

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalDialog layout="fullscreen">
          <ModalClose sx={{ width: "35px" }} />
          <DialogTitle className="text-2xl font-bold text-gray-800 flex items-center">
            Configuración para el Esqueleto de Fixture
            <div className="flex items-center">
              <label className="mr-2 text-sm font-medium">
                | Limpiar Formulario
              </label>
              <input
                type="checkbox"
                checked={clearForm}
                onChange={(e) => setClearForm(e.target.checked)}
              />
            </div>
          </DialogTitle>
          <DialogContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {[
                  "idtypephase",
                  "nro_fecha",
                  "idgrupo1",
                  "idgrupo2",
                  "nro_grupo1",
                  "nro_grupo2",
                  "date_match",
                  "time_match",
                  "idsede",
                  "tag_final",
                  "nro_match",
                ].map((field) => (
                  <div key={field} className="space-y-1">
                    <label className="text-sm font-medium">{field}</label>
                    <input
                      type={
                        field === "date_match"
                          ? "date"
                          : field === "time_match"
                            ? "time"
                            : "text"
                      }
                      name={field}
                      value={formData[field] || ""}
                      onChange={handleChange}
                      className="w-full p-1 border rounded"
                    />
                  </div>
                ))}
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="submit"
                  className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
                >
                  Enviar
                </button>
              </div>
            </form>

            {/* Mostrar registros */}
            <div className="mt-8">
              <h3 className="text-xl font-semibold mb-4">Registros Creados</h3>
              <table className="w-full border">
                <thead>
                  <tr>
                    {[
                      "idtypephase",
                      "nro_fecha",
                      "idgrupo1",
                      "idgrupo2",
                      "nro_grupo1",
                      "nro_grupo2",
                      "date_match",
                      "time_match",
                      "idsede",
                      "tag_final",
                      "nro_match",
                    ].map((header) => (
                      <th key={header} className="border px-2 py-1">
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {skeleton.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => handleRowClick(item)}
                      className="cursor-pointer hover:bg-gray-100"
                    >
                      {[
                        "idtypephase",
                        "nro_fecha",
                        "idgrupo1",
                        "idgrupo2",
                        "nro_grupo1",
                        "nro_grupo2",
                        "date_match",
                        "time_match",
                        "idsede",
                        "tag_final",
                        "nro_match",
                      ].map((field) => (
                        <td key={field} className="border px-2 py-1">
                          {item[field]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </DialogContent>
        </ModalDialog>
      </Modal>

      {/* Modal de actualización */}
      {isUpdateModalOpen && (
        <ModalFormUpdate
          open={isUpdateModalOpen}
          setOpen={setIsUpdateModalOpen}
          rowData={selectedRow}
          fetchSkeletonMatches={fetchSkeletonMatches}
        />
      )}
    </>
  );
};

export default ModalConfigSkeletonFixture;
